(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-search-overlay"] && !Shopify.designMode) return;
  try {
    class HeaderSearchOverlay extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('dialog');
      this.input = this.querySelector('input[type="search"]');
      this.closeButton = this.querySelector('[data-header-search-close]');
      this.previouslyFocused = null;
      this.handleTriggerClick = this.onTriggerClick.bind(this);
      this.handlePredictiveResults = this.fillPredictiveProducts.bind(this);

      document.addEventListener('click', this.handleTriggerClick);
      this.addEventListener('predictive-search:rendered', this.handlePredictiveResults);
      this.closeButton?.addEventListener('click', () => this.close());
      this.dialog?.addEventListener('cancel', (event) => {
        event.preventDefault();
        this.close();
      });
      this.dialog?.addEventListener('click', (event) => {
        if (event.target === this.dialog) this.close();
      });
      this.dialog?.addEventListener('close', () => this.afterClose());
    }

    disconnectedCallback() {
      document.removeEventListener('click', this.handleTriggerClick);
      this.removeEventListener('predictive-search:rendered', this.handlePredictiveResults);
    }

    onTriggerClick(event) {
      const trigger = event.target.closest?.('[data-header-search-trigger]');
      if (trigger) this.open(trigger);
    }

    fillPredictiveProducts() {
      const results = this.querySelector('#predictive-search-results');
      const fallbackProducts = Array.from(this.querySelectorAll('[data-search-fallback-product]'));
      const fallbackSuggestions = Array.from(this.querySelectorAll('[data-search-fallback-suggestion]'));

      if (!results) return;

      const totalResults = Number(results.querySelector('[data-total-results]')?.dataset.totalResults || 0);

      let wrapper = results.querySelector('#predictive-search-results-groups-wrapper');
      let productList = results.querySelector('#predictive-search-results-products-list');
      let suggestionList = results.querySelector('#predictive-search-results-queries-list');

      if (!wrapper) {
        wrapper = document.createElement('div');
        wrapper.id = 'predictive-search-results-groups-wrapper';
        wrapper.className =
          'predictive-search__results-groups-wrapper predictive-search__results-groups-wrapper--no-suggestions';
        results.prepend(wrapper);
      }

      if (!suggestionList && fallbackSuggestions.length) {
        const group = document.createElement('div');
        const groupInner = document.createElement('div');
        const heading = document.createElement('h2');

        group.className = 'predictive-search__result-group';
        heading.id = 'predictive-search-queries';
        heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
        heading.textContent = this.querySelector('#HeaderSearchTrending')?.textContent.trim() || 'Suggestions';

        suggestionList = document.createElement('ul');
        suggestionList.id = 'predictive-search-results-queries-list';
        suggestionList.className = 'predictive-search__results-list list-unstyled';
        suggestionList.setAttribute('role', 'group');
        suggestionList.setAttribute('aria-labelledby', heading.id);

        groupInner.append(heading, suggestionList);
        group.append(groupInner);
        wrapper.prepend(group);
      }

      if (suggestionList) {
        const predictiveSuggestions = Array.from(suggestionList.children);
        predictiveSuggestions.slice(5).forEach((suggestion) => suggestion.remove());

        const suggestionUrl = (element) => element.querySelector('a')?.getAttribute('href') || '';
        const shownSuggestionUrls = new Set(predictiveSuggestions.slice(0, 5).map(suggestionUrl).filter(Boolean));
        let suggestionCount = Math.min(predictiveSuggestions.length, 5);

        for (const fallbackSuggestion of fallbackSuggestions) {
          if (suggestionCount >= 5) break;

          const fallbackUrl = suggestionUrl(fallbackSuggestion);
          if (!fallbackUrl || shownSuggestionUrls.has(fallbackUrl)) continue;

          const item = fallbackSuggestion.cloneNode(true);
          suggestionCount += 1;
          shownSuggestionUrls.add(fallbackUrl);
          item.id = `predictive-search-option-query-fallback-${suggestionCount}`;
          item.className = 'predictive-search__list-item header-search-overlay__fallback-suggestion';
          item.setAttribute('role', 'option');
          item.setAttribute('aria-selected', 'false');
          item.querySelector('a')?.classList.add('predictive-search__item');
          item.querySelector('a')?.setAttribute('tabindex', '-1');
          suggestionList.append(item);
        }

        wrapper.classList.remove('predictive-search__results-groups-wrapper--no-suggestions');
      }

      if (!productList) {
        const group = document.createElement('div');
        const groupInner = document.createElement('div');
        const heading = document.createElement('h2');

        group.className = 'predictive-search__result-group';
        heading.id = 'predictive-search-products';
        heading.className = 'predictive-search__heading text-body caption-with-letter-spacing';
        heading.textContent = this.querySelector('#HeaderSearchRecommended')?.textContent.trim() || 'Products';

        productList = document.createElement('ul');
        productList.id = 'predictive-search-results-products-list';
        productList.className = 'predictive-search__results-list list-unstyled';
        productList.setAttribute('role', 'group');
        productList.setAttribute('aria-labelledby', heading.id);

        groupInner.append(heading, productList);
        group.append(groupInner);
        wrapper.append(group);
      }

      wrapper.classList.remove('predictive-search__results-groups-wrapper--no-products');

      const productUrl = (element) => {
        const rawUrl = element.dataset.productUrl || element.querySelector('a[href*="/products/"]')?.getAttribute('href');
        if (!rawUrl) return '';

        return new URL(rawUrl, window.location.origin).pathname.replace(/\/$/, '');
      };
      const predictiveProducts = Array.from(productList.children);
      predictiveProducts.slice(4).forEach((product) => product.remove());
      predictiveProducts.slice(0, 4).forEach((product) => product.querySelector('a')?.setAttribute('tabindex', '-1'));

      const shownUrls = new Set(predictiveProducts.slice(0, 4).map(productUrl).filter(Boolean));
      let displayedCount = Math.min(predictiveProducts.length, 4);

      for (const fallbackProduct of fallbackProducts) {
        if (displayedCount >= 4) break;

        const fallbackUrl = productUrl(fallbackProduct);
        if (!fallbackUrl || shownUrls.has(fallbackUrl)) continue;

        const item = fallbackProduct.cloneNode(true);
        displayedCount += 1;
        shownUrls.add(fallbackUrl);
        item.id = `predictive-search-option-product-fallback-${displayedCount}`;
        item.className = 'predictive-search__list-item header-search-overlay__fallback-product';
        item.setAttribute('role', 'option');
        item.setAttribute('aria-selected', 'false');
        item.querySelectorAll('[id]').forEach((element) => element.removeAttribute('id'));
        item.querySelectorAll('[aria-labelledby]').forEach((element) => element.removeAttribute('aria-labelledby'));
        item.querySelector('a')?.setAttribute('tabindex', '-1');
        productList.append(item);
      }

      results.querySelector('[data-header-search-no-results]')?.remove();
      if (totalResults === 0 && this.input?.value.trim()) {
        const message = document.createElement('p');
        const template = this.dataset.noResultsTemplate || 'No results found for “__SEARCH_TERM__”';

        message.className = 'header-search-overlay__no-results';
        message.dataset.headerSearchNoResults = '';
        message.setAttribute('role', 'status');
        message.textContent = template.replace('__SEARCH_TERM__', this.input.value.trim());
        results.prepend(message);
      }
    }

    open(trigger) {
      if (!this.dialog || this.dialog.open) return;
      this.previouslyFocused = trigger;

      if (!this.input?.value.trim()) {
        const predictiveSearch = this.querySelector('predictive-search');
        predictiveSearch?.close?.(true);
        predictiveSearch?.removeAttribute('open');
        predictiveSearch?.removeAttribute('loading');
      }

      this.dialog.showModal();
      document.body.classList.add('search-overlay-open');
      requestAnimationFrame(() => this.input?.focus());
    }

    close() {
      if (this.dialog?.open) this.dialog.close();
    }

    afterClose() {
      document.body.classList.remove('search-overlay-open');
      this.previouslyFocused?.focus();
      this.previouslyFocused = null;
    }
  }

  if (!customElements.get('header-search-overlay')) {
    customElements.define('header-search-overlay', HeaderSearchOverlay);
  }
  } catch(e) { console.error(e); }
})();

})();
